var map = {
	"./smiley J.svg": "e7d2",
	"./smiley O.svg": "a75c",
	"./smiley R.svg": "bfc7",
	"./smiley VJ.svg": "8dae",
	"./smiley VV.svg": "e7f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "524e";